export function getRowStyle(activity) {
  const a = activity.toLowerCase();
  if (a.includes("kickoff") || a.includes("orientation")) return { bg: "#FFF0F6", accent: "#C026D3", dot: "#F0ABFC" };
  if (a.includes("stand-up")) return { bg: "#F0FDF4", accent: "#059669", dot: "#6EE7B7" };
  if (a.includes("planning")) return { bg: "#EEF2FF", accent: "#4F46E5", dot: "#A5B4FC" };
  if (a.includes("multi-subject") || a.includes("concept study")) return { bg: "#F0F9FF", accent: "#0284C7", dot: "#7DD3FC" };
  if (a.includes("revision")) return { bg: "#F0F9FF", accent: "#0369A1", dot: "#7DD3FC" };
  if (a.includes("move to exam")) return { bg: "#FEF2F2", accent: "#B91C1C", dot: "#FCA5A5" };
  if (a.includes("internal assessment exam") || a.includes("mock university exam") || a.includes("au exam")) return { bg: "#FEF2F2", accent: "#DC2626", dot: "#FCA5A5" };
  if (a.includes("post-exam break") || a.includes("short break") || a.includes("lunch")) return { bg: "#F9FAFB", accent: "#9CA3AF", dot: "#D1D5DB" };
  if (a.includes("deep dive") || a.includes("cross-learning")) return { bg: "#E7F0F6", accent: "#1B4F72", dot: "#93C5E4" };
  if (a.includes("bridge")) return { bg: "#FDF4FF", accent: "#9333EA", dot: "#D8B4FE" };
  if (a.includes("project impl") || a.includes("demo prep")) return { bg: "#EEF2FF", accent: "#4338CA", dot: "#818CF8" };
  if (a.includes("brainstorm")) return { bg: "#E7F0F6", accent: "#1B4F72", dot: "#7BA7C9" };
  if (a.includes("collaboration") || a.includes("peer")) return { bg: "#F0FDF4", accent: "#16A34A", dot: "#86EFAC" };
  if (a.includes("review") || a.includes("demo")) return { bg: "#FFF1F2", accent: "#E11D48", dot: "#FDA4AF" };
  if (a.includes("innovation") || a.includes("exploration")) return { bg: "#F5F3FF", accent: "#7C3AED", dot: "#C4B5FD" };
  if (a.includes("skill")) return { bg: "#ECFDF5", accent: "#059669", dot: "#6EE7B7" };
  if (a.includes("retrospective")) return { bg: "#E7F0F6", accent: "#143B56", dot: "#BFDBFE" };
  if (a.includes("quiz") || a.includes("assessment") || a.includes("practical")) return { bg: "#E7F0F6", accent: "#1B4F72", dot: "#B6D4E8" };
  if (a.includes("progress review") || a.includes("faculty")) return { bg: "#EEF2FF", accent: "#4338CA", dot: "#A5B4FC" };
  if (a.includes("contribution")) return { bg: "#F0FDF4", accent: "#15803D", dot: "#86EFAC" };
  if (a.includes("system design")) return { bg: "#F5F3FF", accent: "#6D28D9", dot: "#C4B5FD" };
  if (a.includes("code review") || a.includes("knowledge sharing")) return { bg: "#FFF1F2", accent: "#BE185D", dot: "#FBCFE8" };
  if (a.includes("concept learning")) return { bg: "#F0F9FF", accent: "#0284C7", dot: "#7DD3FC" };
  if (a.includes("project work")) return { bg: "#EEF2FF", accent: "#4F46E5", dot: "#A5B4FC" };
  return { bg: "#FFFFFF", accent: "#6B7280", dot: "#D1D5DB" };
}
export const toDD = (iso) => {
  if (!iso) return iso;
  const [y, m, d] = iso.split("-");
  return `${d}-${m}-${y}`;
};
const DAY_NAME_ALIASES = {
  mon: "Monday", monday: "Monday",
  tue: "Tuesday", tues: "Tuesday", tuesday: "Tuesday",
  wed: "Wednesday", wednesday: "Wednesday",
  thu: "Thursday", thur: "Thursday", thurs: "Thursday", thursday: "Thursday",
  fri: "Friday", friday: "Friday",
};

function canonDayName(raw) {
  return DAY_NAME_ALIASES[String(raw || "").toLowerCase()] || "";
}

export const parseDayKey = (raw) => {
  const s = String(raw || "").trim();
  if (!s) return null;
  // "Week 3 - Wednesday (11-06-2026)" or "Week 3 Wednesday"
  let m = s.match(/Week\s*(\d+)\s*[-–]?\s*(\w+)/i);
  if (m) {
    const dayName = canonDayName(m[2]);
    if (dayName) return { week: parseInt(m[1], 10), dayName };
  }
  // "W1-Monday" / "W1_Mon"
  m = s.match(/^W(\d+)\s*[-–_]\s*(\w+)/i);
  if (m) {
    const dayName = canonDayName(m[2]);
    if (dayName) return { week: parseInt(m[1], 10), dayName };
  }
  const calM = s.match(/^(Monday|Tuesday|Wednesday|Thursday|Friday),/i);
  if (calM) {
    return { week: 1, dayName: canonDayName(calM[1]), rawDate: s };
  }
  const plain = canonDayName(s);
  if (plain) return { week: 1, dayName: plain };
  return null;
}

export const shortSubject = (name) => {
  if (!name || name.length <= 6) return name;
  const skip = new Set(["and", "of", "the", "for", "in", "to", "a", "&"]);
  const words = name.trim().split(/[\s\-\/]+/);
  const initials = words.filter(w => w && !skip.has(w.toLowerCase())).map(w => w[0].toUpperCase()).join("");
  return initials.length > 1 ? initials : name.slice(0, 6);
}

export const getDateForWeekDayFE = (calMap, week, dayName) => {
  if (!calMap) return null;
  const entry = calMap.find(e => e.week === week && e.day === dayName);
  return entry ? entry.date : null;
};

export const getWeekMeta = (calendarMeta) => {
  if (!calendarMeta) return { iaWeeks: new Set(), auWeeks: new Set(), mockWeek: null };
  return {
    iaWeeks: new Set(calendarMeta.iaWeekNums || []),
    auWeeks: new Set(calendarMeta.auWeekNums || []),
    mockWeek: calendarMeta.mockWeekNum || null,
  };
}


